import React, {ReactElement, ReactNode} from 'react';
import {CSSTransition} from 'react-transition-group';
import {nextPaint as deferTransition} from 'shared/utils/nextPaint';
import {animationDuration as duration} from 'ui/theme';

type EventCallback = () => void;

type AnimateProps = {
  mount: boolean;
  children: ReactNode;

  onMount?: EventCallback;
  onUnmount?: EventCallback;
  beforeMount?: EventCallback;
  beforeUnmount?: EventCallback;
};

export const Animate = ({
  mount,
  children,
  onMount,
  onUnmount,
  beforeMount,
  beforeUnmount,
}: AnimateProps): ReactElement => (
  <CSSTransition
    in={mount}
    timeout={deferTransition(duration.primary)}
    classNames='is'
    onEnter={beforeMount}
    onExit={beforeUnmount}
    onEntered={onMount}
    onExited={onUnmount}
    mountOnEnter
    unmountOnExit
  >
    {children}
  </CSSTransition>
);
